import backArrowImage from '../img/back_arrow.png'
import viewsCountImage from '../img/views_count_image.png' 
import { useSearchParams } from 'react-router-dom';

import '../css/news_page.css'
import BottomMenuBetting from './BottomMenuBettings';
import BottomMenuCasino from './BottomMenuCasino';
import { useEffect } from 'react';
import restApiHost from '..';

function NewsPage({news, activeCategory, activeSubcategory, setActiveSubcategory, countryName, phoneNumber, setActiveCommunitySubcategory}){
    const [searchParams] = useSearchParams();
    
    const newsId = searchParams.get('news_id');
    const currentNews = news.find(item => item.id === parseInt(newsId, 10));
    
    useEffect(() => {
        setActiveSubcategory('Сообщество')
        setActiveCommunitySubcategory('Новости')

        async function incrementViews () {
            const data = {
                id: parseInt(newsId, 10)
            }
        await fetch(restApiHost + '/api/increment-views/', {
            method: 'POST', // Указываем метод
            headers: {
                'Content-Type': 'application/json', // Указываем, что отправляем JSON
            },
            body: JSON.stringify(data), // Превращаем объект в строку
            });
        }
        incrementViews();
    }, [])
    if (!news || !newsId || !currentNews) {
        return; // или null, или спиннер
    }
    return <div className="news-page">
        <div className="back-arrow-image-container" onClick={() => window.history.back()}>
            <img className="back-arrow-image" src={backArrowImage} alt='error'/>
        </div>
        <div className="news-single-title">{currentNews?.title}</div>
        <div className='news-single-banner-container'>
            <img className='new-single-banner' src={currentNews?.image} alt='error'/>
        </div>
                <div className="news-single-additional-info-container">
            <div className="news-single-date">{currentNews?.date}</div>
            <div className="news-single-views-count-container">
                <div className="news-single-views-count">{currentNews?.views_count}</div>
                <div className="news-single-views-count-image-container">
                    <img className="news-single-views-count-image" src={viewsCountImage} alt='error'/>
                </div>
            </div>
        </div>
            <div className='news-single-text'>{currentNews?.text}</div>
        {(currentNews.button_text && currentNews.button_link) &&
            <div className='news-button' onClick={() => window.open(currentNews?.button_link, '_self')}>
                <div className='news-button-text'>{currentNews?.button_text}</div>
            </div>
        }
        <div className='news-breakline' style={{minHeight: (currentNews?.button_text && currentNews?.button_link) ? '150px': '90px'}}/>
        {activeCategory === 'Казино' ? (
        <BottomMenuCasino activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName} phoneNumber={phoneNumber}/>
    ) : (
        <BottomMenuBetting activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName}/>
    )}
    </div>
};

export default NewsPage;